var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappybati(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 39,
    viewBox: "0 0 200 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "HappyBati.fr",
    transform: "translate(200 31)",
    fill: "#fa8e20",
    fontSize: 30,
    fontFamily: "Futura-Bold, Futura",
    fontWeight: 700,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -199.77,
    y: 0,
    fill: "#000"
  }, "HappyBati"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#fa8e20"
  }, ".fr"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappybati);
export default __webpack_public_path__ + "static/media/happybati.63e0f06945efc484365e099dd709d81d.svg";
export { ForwardRef as ReactComponent };